import React from "react";
import ReactDOM from "react-dom/client";

import "uikit/dist/js/uikit.min.js";
import "uikit/dist/css/uikit.min.css";
import "mediaelement/full.js";
import "./scripts.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
